export default "<app-kros></app-kros>\n<app-vaterpolo></app-vaterpolo>\n<app-ostali></app-ostali>";